<template>
  <div id="header" :class="{'hidden': currentStatus !== 0}">
    <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 163"><path d="M82.676 0c-18.3 0-33.069 14.158-33.069 31.628 0 6.191 1.765 11.944 5.075 16.809h15.866a20.303 20.255 0 0 1-7.937-16.146c0-11.06 9.042-20.131 20.065-20.131 11.02 0 20.058 9.072 20.058 20.131 0 6.635-3.081 12.385-7.93 16.146h15.867c3.085-4.865 5.074-10.618 5.074-16.809C115.745 14.154 100.973 0 82.676 0zm100.529 1.544v46.44h35.055v-9.952h-23.373V30.07h20.503v-9.72h-20.503v-8.852h23.373V1.544zM0 1.99v46.448h11.471v-17.48h18.736v17.48H41.67V1.989H30.207v18.58H11.47V1.988zm123.682 0v46.448h11.464V24.99l10.36 16.145h6.39l10.368-15.927v23.228h11.237V1.989H164.9l-16.305 24.772L132.284 1.99zM71.877 36.714c1.547 4.644 5.727 7.956 10.8 7.956 5.068 0 9.263-3.312 10.806-7.956zm-47.41 21.675C10.58 58.39 0 68.561 0 82.5c0 13.929 10.58 24.1 24.468 24.1 11.684 0 20.283-7.074 22.708-17.69h-12.12c-1.764 4.205-5.52 6.85-10.588 6.85-7.498 0-12.785-5.526-12.785-13.268 0-7.738 5.287-13.268 12.785-13.268 5.069 0 8.82 2.432 10.587 6.856h12.12c-2.424-10.615-11.023-17.69-22.707-17.69zm77.164.437v46.448h35.055V95.32h-23.372v-7.963h20.503v-9.734h-20.503v-8.845h23.372v-9.953zm-47.621.226v46.44h11.463V92.006h8.602l8.82 13.486h13.661L85.757 89.347c4.853-2.878 7.71-7.96 7.71-13.93 0-10.177-7.709-16.365-19.173-16.365zm158.073 0v10.39h13.223v36.05h11.463v-36.05H250v-10.39zm-67.467.219v46.44h18.524c14.55 0 24.913-9.726 24.913-23.439S177.69 59.271 163.14 59.271zm49.826 0v46.447h11.463V59.271zM65.254 69.44h8.602c4.408 0 7.937 2.433 7.937 6.194 0 3.76-3.53 6.193-7.937 6.193h-8.602zm90.825.227h7.061c7.497 0 13.223 5.526 13.223 12.604 0 7.299-5.726 13.042-13.223 13.042h-7.06zM0 116.326v46.448h23.373c10.362 0 16.53-5.089 16.53-12.83 0-4.865-2.644-9.734-8.375-11.06 3.967-1.328 6.39-5.967 6.39-10.172 0-7.518-5.733-12.386-15.875-12.386zm60.187 0L40.56 162.774h12.347l3.09-7.964h19.618l2.87 7.964h12.34l-19.62-46.448zm34.61 0v46.448h11.463v-25.435l22.27 25.435h8.813v-46.448h-11.456v26.106l-22.27-26.106zm52.25.234V163h11.464v-9.516l6.834-7.956L177.911 163h14.326l-19.174-26.098 17.633-20.342h-13.668l-18.517 21.23v-21.23zm-135.364 9.5h8.6c4.409 0 6.835 1.545 6.835 4.423 0 2.874-2.426 5.085-6.834 5.085h-8.601zm54.01 3.541l6.177 15.701H59.523zm-54.23 14.375h10.58c4.188 0 6.616 1.545 6.616 4.423 0 2.874-1.986 4.867-6.835 4.867h-10.36z" fill="#DB1E31"/></svg>
    <h1>{{ getHeaderText }}</h1>
  </div>
</template>

<script>
export default {
  name: 'TheHeader',
  computed: {
    currentStatus () {
      return this.$store.getters.currentStatus
    },
    getHeaderText () {
      return this.$store.getters.getHeaderText
    }
  }
}
</script>

<style lang="scss" scoped>
  #header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 50px;
    .logo {
      display: block;
      height: 88px;
    }
    h1 {
      font-family: 'AvantGardeGothicC';
      font-size: 33px;
      font-size: 30px;
      color: #000;
      max-width: 460px;
      margin: 0 92px;
      opacity: 1;
      transition: all 0.2s ease-in-out;
    }
    span {
      color: #DB1E31;
    }
  }
  .hidden {
    opacity: 0;
  }
  @media only screen and (max-width: 768px) {
    #header {
      flex-direction: column;
      svg {
        margin: 15px 20px;
      }
      h1 {
        margin-right: 20px;
        margin-left: 20px;
        text-align: center;
        font-size: 24px;
      }
    }
  }
</style>
